var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vuw-logo",attrs:{"src":"/assets/images/vu-logo-blauw.svg","alt":"Vrije Universiteit Amsterdam"}})}
var staticRenderFns = []

export { render, staticRenderFns }